module.exports = __webpack_public_path__ + "static/media/galeryCeilings5.d1f455bb.jpg";